import { LoanResortsService } from './../../services/loan-resorts.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';

import * as moment from 'moment';
import { of } from 'rxjs';
import {
  mergeMap,
  filter,
  tap,
  map,
  toArray,
  pluck,
  switchMap,
} from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-appoved-loan-report-commodity',
  templateUrl: './appoved-loan-report-commodity.component.html',
  styleUrls: ['./appoved-loan-report-commodity.component.css'],
})
export class AppovedLoanReportCommodityComponent implements OnInit {
  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  dataToShow: any;
  filterWnameArr: any;
  dataRec: boolean;
  fromDate: any;
  toDate: any;
  warehouseDataToShow: any;
  whrDataFlag: boolean = false;
  loanDataFlag: boolean = false;
  stateDataToShow: any;
  grainDataToShow: any;
  grinDataFlag: boolean = true;
  loanAppsLoaded: Boolean = false;

  emailForm: FormGroup;
  sendingEmail: boolean = false;

  isOneWeekFilter: boolean = false;
  isCurrentMonthFilter: boolean = false;
  isOneMonthFilter: boolean = false;
  isCurrentYearFilter: boolean = false;
  isOneYearFilter: boolean = false;

  constructor(
    private fb: FormBuilder,
    private lservice: LoanResortsService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {}

  disableAllFilterBoolean() {
    this.isOneWeekFilter = false;
    this.isCurrentMonthFilter = false;
    this.isOneMonthFilter = false;
    this.isCurrentYearFilter = false;
    this.isOneYearFilter = false;
  }

  setFilterBoolean(range) {
    this.disableAllFilterBoolean();
    switch (range) {
      case '1W':
        this.isOneWeekFilter = true;
        return;
      case 'MTD':
        this.isCurrentMonthFilter = true;
        return;
      case '1M':
        this.isOneMonthFilter = true;
        return;
      case 'YTD':
        this.isCurrentYearFilter = true;
        return;
      case '1Y':
        this.isOneYearFilter = true;
        return;
    }
  }

  ngOnInit() {
    this.emailForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'),
        ],
      ],
    });

    this.route.queryParams
      .pipe(
        switchMap((value) => of(value)),
        tap((value) => this.setFilterBoolean(value.range)),
        tap((value) => {
          if (value.range) {
            this.fromDate = null;
            this.toDate = null;
          } else {
            this.fromDate = value.fromDate;
            this.toDate = value.toDate;
          }
        }),
        map((value) => {
          const params = { ...value };
          this.p = params.page || 1;

          params.page = this.p;
          params.limit = this.itemsPerPage;
          return params;
        }),
        map((value) => {
          let query: any = {
            page: value.page,
            limit: value.limit,
          };

          if (value.fromDate && value.toDate) {
            query.fromDate = value.fromDate;
            query.toDate = value.toDate;
          }

          return query;
        })
      )
      .subscribe((query) => {
        console.log('query', query);
        this.getApprovedLoanByCommodity(query);
      });
  }

  onEmailSubmit() {
    const { fromDate, toDate, range } = this.route.snapshot.queryParams;

    const query: any = {
      sendBy: 'email',
      email: this.emailForm.get('email').value,
      fileName: `${
        range ? `${range}_` : ''
      }MIS_Commodity_Wise_Approved_Loans-${new Date().toDateString()}`,
      reportName: 'Commodity wise Approved Loans',
    };

    if (fromDate && toDate) {
      query.fromDate = fromDate;
      query.toDate = toDate;
    }

    if (range) query.range = range;

    this.loanAppsLoaded = false;
    this.sendingEmail = true;

    this.lservice.approvedLoanByCommodityByDateRange(query).subscribe(
      () => {
        this.sendingEmail = false;
        this.loanAppsLoaded = true;
        this.toastr.success(
          `Email sent to  ${this.emailForm.get('email').value}`
        );
      },
      () => {
        this.sendingEmail = false;
        this.loanAppsLoaded = true;
        this.toastr.error('Cant send email');
      }
    );
  }

  getApprovedLoanByCommodity(filter = {}) {
    this.loanAppsLoaded = false;

    this.lservice.approvedLoanByCommodityByDateRange(filter).subscribe(
      (data) => {
        this.loanAppsLoaded = true;
        this.dataRec = true;
        if (data['success']) {
          this.dataToShow = data['data'];
        } else {
          this.toastr.error('Something went wrong, please try again.');
        }
      },
      () => {
        this.toastr.error('Something went wrong, please try again.');
        this.loanAppsLoaded = true;
      }
    );
  }

  getReportbyDateRange() {
    if (!this.fromDate || !this.toDate) {
      return;
    }

    this.router.navigate(['/approved-loan-reports-cmdt'], {
      queryParams: {
        fromDate: this.fromDate,
        toDate: this.toDate,
      },
    });
  }

  onResetClick() {
    this.router.navigateByUrl('/approved-loan-reports-cmdt');
  }

  fileWriteObj(data) {
    return {
      Commodity: data._id || 'N.A.',
      'Loan Amount': data.loanAmount,
      'Number of Loans': data.count,
    };
  }

  downloadFile(fileType = 'csv') {
    const { fromDate, toDate } = this.route.snapshot.queryParams;

    const query: any = {};

    if (fromDate && toDate) {
      query.fromDate = fromDate;
      query.toDate = toDate;
    }

    this.loanAppsLoaded = false;
    this.lservice
      .approvedLoanByCommodityByDateRange(query)
      .pipe(
        pluck('data'),
        mergeMap((values: any[]) => of(...values)),
        map((value) => {
          return this.fileWriteObj(value);
        }),
        toArray()
      )
      .subscribe(
        (loanApps: any) => {
          this.loanAppsLoaded = true;
          if (fileType === 'pdf') {
            this.writeToPDF(loanApps);
          } else {
            this.writeToCSV(loanApps);
          }
        },
        () => {
          this.loanAppsLoaded = true;
          this.toastr.error('Something went wrong, please try again.');
        }
      );
  }

  print() {}

  writeToCSV(data) {
    let headers = [];
    if (data.length) {
      headers = Object.keys(data[0]);
    }

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: headers,
      showTitle: false,
      title: 'name',
      useBom: false,
      removeNewLines: true,
      noDownload: false,
    };

    new AngularCsv(
      data,
      'MIS_Commodity_Wise_Approved_Loans-' + new Date().toDateString(),
      options
    );
  }

  writeToPDF(data) {
    let headers = [];
    if (data.length) {
      headers = Object.keys(data[0]);
    }

    const doc = new jsPDF('landscape');
    const rows = data.map((d) => headers.map((h) => d[h]));

    doc.setFontSize(9);
    doc.autoTable(headers, rows);
    doc.save(
      'MIS_Commodity_Wise_Approved_Loans-' + new Date().toDateString() + '.pdf'
    );
  }

  onRowClick(data) {
    const commodity = data._id;
    this.router.navigate(['/approved-loan-reports-cmdt', commodity], {
      queryParams: {
        page: 1,
      },
      queryParamsHandling: 'merge',
    });
  }

  getOneWeekReport() {
    const today = moment().format('YYYY-MM-DD');
    const weekStart = moment().subtract(1, 'weeks').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt'], {
      queryParams: {
        fromDate: weekStart,
        toDate: today,
        range: '1W',
        page: 1,
      },
    });
  }

  getCurrentMonthReport() {
    const today = moment().format('YYYY-MM-DD');
    const monthStart = moment().startOf('month').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt'], {
      queryParams: {
        fromDate: monthStart,
        toDate: today,
        range: 'MTD',
        page: 1,
      },
    });
  }

  getOneMonthReport() {
    const today = moment().format('YYYY-MM-DD');
    const monthStart = moment().subtract(1, 'months').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt'], {
      queryParams: {
        fromDate: monthStart,
        toDate: today,
        range: '1M',
        page: 1,
      },
    });
  }

  getCurrentYearReport() {
    const today = moment().format('YYYY-MM-DD');
    const yearStart = moment().startOf('year').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt'], {
      queryParams: {
        fromDate: yearStart,
        toDate: today,
        range: 'YTD',
        page: 1,
      },
    });
  }

  getOneYearReport() {
    const today = moment().format('YYYY-MM-DD');
    const yearStart = moment().subtract(1, 'years').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt'], {
      queryParams: {
        fromDate: yearStart,
        toDate: today,
        range: '1Y',
        page: 1,
      },
    });
  }

  goBack() {
    this.router.navigateByUrl('/reports');
  }
}
